export enum GroupPermissionType {
  Base = 'base',
  Current = 'curr',
}

export enum PermissionGroupPrefix {
  Generic = 'CPG_',
  Class = 'CL_',
}
